import CapchaComponent from "./CapchaComponent";

export default CapchaComponent;
